module.exports = __webpack_public_path__ + "img/style-tile-mobile.7c30cd57.png";